import Notifier from '@/libs/Notifier';
import HbiImagemHomeService from '@/services/SistemaDKP/sls-imagem-home.service';
import SLSMarcaService from '@/services/SistemaDKP/sls-marca.service';
import SLSItemService from '@/services/SistemaDKP/SLSItem.service';
import SLSFamiliaComercialService from '@/services/SistemaDKP/SLSFamiliaComercial.service';

export default class HomeService {
  constructor() {
    this.imagemHomeService = new HbiImagemHomeService();
    this.esMarcaService = new SLSMarcaService();
    this.slsItemService = new SLSItemService();
    this.sLSFamiliaComercialService = new SLSFamiliaComercialService();
    this.notify = new Notifier();
  }

  async loadingDadosHome() {
    try {
      await this.imagemHomeService.findAll();
      await this.esMarcaService.findAll();
      await this.slsItemService.findAll();
      await this.sLSFamiliaComercialService.getProdutosDestaque();
    } catch (error) {
      this.notify.error(error.message);
    }
  }

  async pushCalagoroMarca(referencia) {
    try {
      this.$router.push({ name: 'produtos-catalogo-marca', params: { codMarca: referencia.marca.des_marca } });
      this.notify.success(`Ir para Calagoro da Marca ${referencia.marca.des_marca}`);
    } catch (error) {
      this.notify.error(error.message);
    }
  }
}
